import React from 'react';
import { SwitchControl } from '../../Toggle/Toggle';

type SettingsToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
};

export function SettingsToggle({ checked, onChange, disabled }: SettingsToggleProps) {
  return (
    <SwitchControl
      size="sm"
      checked={checked}
      onChange={onChange}
      onClick={(e) => e.stopPropagation()}
      {...(disabled !== undefined ? { disabled } : {})}
    />
  );
}
